import { timeToFloat, hhmmToFloat } from '@/mixins/utils'

import { apiRefOpen, apiGetScaleRef, apiRefClose } from '@/services/firebase'

import moment from 'moment'
import 'moment/locale/pt-br'

export default {
  data () {
    return {
      type: '',

      fbScaleRef: null,

      // utilizado apenas no view scale
      fbScaleDutiesRef: null,
      fbScaleDutiesRefMonth: 0,
      fbScaleDutiesRefYear: 2020,

      firstDayOfCurrentWeek: null,

      actualMonth: 0,
      actualYear: 2020,

      localGroupID: '',
      localScaleID: '',

      // scaleRelatedUsers: [],
      scaleName: '', // SCALE TYPE
      scaleLocation: {
        id: '',
        name: '',
      },
      scaleTurns: [], // ViewScale não usa
      scaleUsers: {},
      // [staging-portaltelemedicina / master-portaltelemedicina]
      // scaleConsultationDuration: 0,
      // [staging-portaltelemedicina / master-portaltelemedicina]

      // Valores de precificação da escala
      scaleValue: 0,
      scaleWeekdaysHourlyRate: 0,
      scaleWeekendHourlyRate: 0,
      scaleDayShiftHourlyRate: 0,
      scaleNightShiftHourlyRate: 0,
      scaleWeekdaysDayShiftHourlyRate: 0,
      scaleWeekdaysNightShiftHourlyRate: 0,
      scaleWeekendDayShiftHourlyRate: 0,
      scaleWeekendNightShiftHourlyRate: 0,

      scaleAvailableShiftColor: '#00cb72',
      scaleOwnedShiftColor: '#2196f3',

      // weeks: null, // EDITSCALE
      weeks: [], // VIEWSCALE

      preLoadedWeeks: [], // VER TODOS

      months: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
      selectMonths: [
        { text: 'Janeiro', value: 0 }, { text: 'Fevereiro', value: 1 }, { text: 'Março', value: 2 },
        { text: 'Abril', value: 3 }, { text: 'Maio', value: 4 }, { text: 'Junho', value: 5 },
        { text: 'Julho', value: 6 }, { text: 'Agosto', value: 7 }, { text: 'Setembro', value: 8 },
        { text: 'Outubro', value: 9 }, { text: 'Novembro', value: 10 }, { text: 'Dezembro', value: 11 },
      ],

      scaleZoom: '1',
      scaleSizes: [
        { text: '100%', value: '1' },
        { text: '90%', value: '0.9' },
        { text: '80%', value: '0.8' },
        { text: '70%', value: '0.7' },
        { text: '60%', value: '0.6' },
        { text: '50%', value: '0.5' },
      ],

      newScaleSizes: [
        // { key: 'scale_1', value: '1', text: '100%' }
        { key: 'scale_100', text: '100%', value: '1' },
        { key: 'scale_90', text: '90%', value: '0.9' },
        { key: 'scale_80', text: '80%', value: '0.8' },
        { key: 'scale_70', text: '70%', value: '0.7' },
        { key: 'scale_60', text: '60%', value: '0.6' },
        { key: 'scale_50', text: '50%', value: '0.5' },
      ],

      startOnMonday: 'waiting',
      startDayOfMonth: 0,
      endDayOfMonth: 0,

      //
      // SELETOR DE PERÍODO
      //

      yearMonth: [],

      lang: {
        formatLocale: {
          // MMMM
          months: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
          // MMM
          monthsShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
          // dddd
          weekdays: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
          // ddd
          weekdaysShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
          // dd
          weekdaysMin: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
          // weekdaysMin: ['Do', 'Se', 'Te', 'Qu', 'Qu', 'Se', 'Sa'],
        },
        yearFormat: 'YYYY',
        monthFormat: 'MMMM',
      },
    }
  },

  computed: {
    /* EditScale.js */
    /* esSelectYears () {
      const currentYear = moment().get('year')
      return [currentYear, currentYear + 1].map((year, key) => ({ text: year, value: year }))
    }, */

    /* ViewScale.js */
    vsSelectYears () {
      const currentYear = new Date().getFullYear()
      const previousYear = currentYear - 1
      const nextYear = currentYear + 1

      return [
        { text: previousYear, value: previousYear },
        { text: currentYear, value: currentYear },
        { text: nextYear, value: nextYear },
      ]
    },
  },

  methods: {

    /**
     *
     * SCALE LOADING
     * -> 04/07 - não aplicado na tela VIEWSCALE
     *
     */

    onReadDutiesUpdate (scaleRequest)
    {
      //
      // DATABASE DATA
      //

      const loadedScale = scaleRequest && scaleRequest.val() ? scaleRequest.val() : false

      //
      // SCALE TURNS
      //

      if (this.type === 'edit')
      {
        let turnShifts = !!loadedScale === true && !!loadedScale.turnos === true && typeof loadedScale.turnos === 'object' ? Object.entries(loadedScale.turnos) : []

        turnShifts = turnShifts.length > 0 ? turnShifts.map(([turnID, turn]) => {
          // VALIDATION
          const isValid = !!turn === true && !!turn.days === true
          const isValidDuration = !!turn.duration === true || !!turn.duration === 0 || turn.duration === '0'
          const isValidHour = !!turn.hour === true || turn.hour === 0 || turn.hour === '0'

          // START TIME
          const turnStartTime = timeToFloat(turn.hour)

          return isValid && isValidDuration && isValidHour ? { turnID, ...turn, turnStartTime } : false
        }).filter(turn => !!turn === true) : []

        this.scaleTurns = turnShifts

        //
        // SCALE USERS
        //

        this.scaleUsers = !!loadedScale === true && !!loadedScale.users === true && typeof loadedScale.users === 'object' ? loadedScale.users : {}

        // [staging-portaltelemedicina / master-portaltelemedicina]
        // this.scaleConsultationDuration = parseInt((loadedScale ?? {})?.tempo_consulta || 0)
        // [staging-portaltelemedicina / master-portaltelemedicina]
      }

      //
      // SCALE RELATED USERS
      //

      /* this.scaleRelatedUsers = (
        !!loadedScale === true &&
        !!loadedScale.relatedUsers === true &&
        typeof loadedScale.relatedUsers === 'object' &&
        Array.isArray(loadedScale.relatedUsers) === false
      ) ? Object.keys(loadedScale.relatedUsers) : [] */

      //
      // SCALE NAME
      //

      this.scaleName = !!loadedScale === true && !!loadedScale.type === true && typeof loadedScale.type === 'string' && loadedScale.type.length > 0 ? loadedScale.type.trim() : ''

      //
      // SCALE LOCAL
      //

      this.scaleLocation = {
        id: !!loadedScale === true && !!loadedScale.placeID === true && loadedScale.placeID.length > 0 ? loadedScale.placeID : '',
        name: !!loadedScale === true && !!loadedScale.local === true && typeof loadedScale.local === 'string' && loadedScale.local.length > 0 ? loadedScale.local.trim() : '',
      }

      this.startOnMonday = !!loadedScale === true && !!loadedScale.startOnMonday === true ? 'yes' : 'no'
      this.startDayOfMonth = !!loadedScale === true && !!loadedScale.startDayOfMonth === true ? loadedScale.startDayOfMonth : 0
      this.endDayOfMonth = !!loadedScale === true && !!loadedScale.endDayOfMonth === true ? loadedScale.endDayOfMonth : 0


      this.scaleValue = !!loadedScale === true && typeof loadedScale.value === 'number' ? loadedScale.value : 0
      this.scaleWeekdaysHourlyRate = !!loadedScale === true && typeof loadedScale.weekdaysHourlyRate === 'number' ? loadedScale.weekdaysHourlyRate : 0
      this.scaleWeekendHourlyRate = !!loadedScale === true && typeof loadedScale.weekendHourlyRate === 'number' ? loadedScale.weekendHourlyRate : 0
      this.scaleDayShiftHourlyRate = !!loadedScale === true && typeof loadedScale.dayShiftHourlyRate === 'number' ? loadedScale.dayShiftHourlyRate : 0
      this.scaleNightShiftHourlyRate = !!loadedScale === true && typeof loadedScale.nightShiftHourlyRate === 'number' ? loadedScale.nightShiftHourlyRate : 0
      this.scaleWeekdaysDayShiftHourlyRate = !!loadedScale === true && typeof loadedScale.weekdaysDayShiftHourlyRate === 'number' ? loadedScale.weekdaysDayShiftHourlyRate : 0
      this.scaleWeekdaysNightShiftHourlyRate = !!loadedScale === true && typeof loadedScale.weekdaysNightShiftHourlyRate === 'number' ? loadedScale.weekdaysNightShiftHourlyRate : 0
      this.scaleWeekendDayShiftHourlyRate = !!loadedScale === true && typeof loadedScale.weekendDayShiftHourlyRate === 'number' ? loadedScale.weekendDayShiftHourlyRate : 0
      this.scaleWeekendNightShiftHourlyRate = !!loadedScale === true && typeof loadedScale.weekendNightShiftHourlyRate === 'number' ? loadedScale.weekendNightShiftHourlyRate : 0


      //
      // SCALE SHIFT COLORS
      //

      this.scaleAvailableShiftColor = !!loadedScale === true && !!loadedScale.availableShiftsColor === true ? loadedScale.availableShiftsColor : '#00cb72'
      this.scaleOwnedShiftColor = !!loadedScale === true && !!loadedScale.ownedShiftsColor === true ? loadedScale.ownedShiftsColor : '#2196f3'

      //
      // DEBUG
      //

      // [24/01/25] console.log(`::: A ESCALA "${this.scaleName}" (ID: ${this.localScaleID}) FOI ATUALIZADA:`, this.type, this.localGroupID)
    },

    //
    // ----------------> 04/07 - não aplicado na tela VIEWSCALE <----------------
    //

    loadScale (groupID, scaleID, type = 'edit') {
      if (this.fbScaleDutiesRef === null) {
        // [24/01/25] console.log(`::: LENDO ESCALA ${scaleID} NO GRUPO ${groupID}...`)

        const fbScaleRef = apiGetScaleRef(groupID, scaleID)
        this.fbScaleRef = fbScaleRef
        this.type = type
        apiRefOpen(this.fbScaleRef, this.onReadDutiesUpdate)
      } else {
        // [24/01/25] console.log('::: CAN\'T LOAD SCALE: Already initialized')
      }
    },

    unloadScale () {
      if (this.fbScaleRef !== null) {
        // [24/01/25] console.log('::: FINALIZANDO ESCALA...')
        apiRefClose(this.fbScaleRef, this.onReadDutiesUpdate)
        this.fbScaleRef = null
      }
    },

    //
    // ----------------> 04/07 - não aplicado na tela VIEWSCALE <----------------
    //

    /**
     *
     * ?
     *
     */

    scaleTimeToFloat (duration = '00:00') {
      const isNumber = typeof duration === 'number' && !isNaN(duration)
      const isInteger = isNumber && Number.isInteger(duration)
      const isFloat = isNumber && !isInteger

      if (isInteger) {
        return duration
      } else if (isFloat) {
        return duration
      } else if (typeof duration === 'string') {
        const explodedDuration = duration.split(':')
        if (parseFloat(explodedDuration[1]) === 0) {
          return parseInt(explodedDuration[0])
        } else {
          return parseFloat(explodedDuration[0] + '.' + explodedDuration[1]).toFixed(2)
        }
      } else {
        return 0
      }
    },

    /**
     *
     * ?
     *
     */

    goToCurrentWeek (day) {
      const elementId = document.body.clientWidth <= 599 ? `week_mobile_${day}` : `week_${day}`
      const element = document.getElementById(elementId)
      const top = !!element === true && !!element.offsetTop === true ? element.offsetTop : false

      // console.log('::: goToCurrentWeek:', document.body.clientWidth, elementId, element, day, top)

      if (top !== false) window.scrollTo(0, document.body.clientWidth <= 599 ? top : (top + 220))
    },

    /**
     *
     * ?
     *
     */

    setYearMonthSetup (cachedFilters = false)
    {
      moment.updateLocale('pt-BR', {
        months: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
        monthsShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
        // monthsParseExact: true,
        weekdays: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
        weekdaysShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
        weekdaysMin: ['Do', 'Se', 'Te', 'Qu', 'Qu', 'Se', 'Sa'],
        week: {
          dow: this.startOnMonday === 'yes' ? 1 : 0,
        },
      })

      const today = moment()

      const currentYear = !!cachedFilters === true && Object.prototype.hasOwnProperty.call(cachedFilters, 'year') ? cachedFilters.year : today.get('year')
      const currentMonth = !!cachedFilters === true && Object.prototype.hasOwnProperty.call(cachedFilters, 'month') ? cachedFilters.month : today.get('month')

      this.actualYear = currentYear
      this.actualMonth = currentMonth

      this.fbScaleDutiesRefYear = currentYear
      this.fbScaleDutiesRefMonth = currentMonth

      this.generateWeeksInMonth(this.actualYear, this.actualMonth, 'weeks')

      //
      // GO TO WEEK
      //

      this.firstDayOfCurrentWeek = moment().startOf('week').format('DD-MM-YYYY')
    },

    /**
     *
     * ?
     *
     */

    rebuildYearMonthWeek () {
      this.generateWeeksInMonth(this.actualYear, this.actualMonth, 'weeks')
    },

    preRebuildYearMonthWeek () {
      this.generateWeeksInMonth(this.actualYear, this.actualMonth, 'prebuild')
    },

    generateWeeksInMonth (year, inputMonth, output = 'prebuild' /* weeks = APENAS "EditScale" */)
    {
      let month = inputMonth
      if (month === 'Janeiro') { month = 0 }
      else if (month === 'Fevereiro') { month = 1 }
      else if (month === 'Março') { month = 2 }
      else if (month === 'Abril') { month = 3 }
      else if (month === 'Maio') { month = 4 }
      else if (month === 'Junho') { month = 5 }
      else if (month === 'Julho') { month = 6 }
      else if (month === 'Agosto') { month = 7 }
      else if (month === 'Setembro') { month = 8 }
      else if (month === 'Outubro') { month = 9 }
      else if (month === 'Novembro') { month = 10 }
      else if (month === 'Dezembro') { month = 11 }

      let outputMonth = month
      if (outputMonth === 0) { outputMonth = 'Janeiro' }
      else if (outputMonth === 1) { outputMonth = 'Fevereiro' }
      else if (outputMonth === 2) { outputMonth = 'Março' }
      else if (outputMonth === 3) { outputMonth = 'Abril' }
      else if (outputMonth === 4) { outputMonth = 'Maio' }
      else if (outputMonth === 5) { outputMonth = 'Junho' }
      else if (outputMonth === 6) { outputMonth = 'Julho' }
      else if (outputMonth === 7) { outputMonth = 'Agosto' }
      else if (outputMonth === 8) { outputMonth = 'Setembro' }
      else if (outputMonth === 9) { outputMonth = 'Outubro' }
      else if (outputMonth === 10) { outputMonth = 'Novembro' }
      else if (outputMonth === 11) { outputMonth = 'Dezembro' }

      // if (!!this.yearMonth === true) this.yearMonth = `${String(month + 1).padStart(2, '0')}/${year}`
      if (!!this.yearMonth === true) {
        // JESUS - Funciona corretamente nas telas de VIEW SCALE ?
        this.actualYear = year
        this.actualMonth = month
        // JESUS - Funciona corretamente nas telas de VIEW SCALE ?

        this.yearMonth = `${outputMonth}/${year}`
      }

      if (output === 'prebuild') {
        // [24/01/25] console.log('::: PRE PROCESSANDO ANO', year, 'MÊS', month, '...')
        // [24/01/25] console.log('::: PRE BUILD WEEKS IN MONTH:', this.yearMonth)
      } else if (output === 'weeks') {
        // [24/01/25] console.log('::: PROCESSANDO ANO', year, 'MÊS', month, '...')
        // [24/01/25] console.log('::: BUILD WEEKS IN MONTH:', this.yearMonth)
      } else {
        // [24/01/25] console.log('::: [BOTH] PROCESSANDO ANO', year, 'MÊS', month, '...')
        // [24/01/25] console.log('::: [BOTH] BUILD WEEKS IN MONTH:', this.yearMonth)
      }

      moment.updateLocale('pt-BR', {
        months: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
        monthsShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
        // monthsParseExact: true,
        weekdays: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
        weekdaysShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
        weekdaysMin: ['Do', 'Se', 'Te', 'Qu', 'Qu', 'Se', 'Sa'],
        week: {
          dow: this.startOnMonday === 'yes' ? 1 : 0,
        },
      })

      // this.getDaysInThisMonth(year, month)

      const yearMonth = moment().set('year', year).set('month', month)
      var firstDate = yearMonth.clone().startOf('month').startOf('week') // clone() preserva o UTC?
      var lastDate = yearMonth.clone().endOf('month').startOf('week') // clone() preserva o UTC?
      if (this.endDayOfMonth > 0) {
        lastDate = yearMonth.clone().add(1, 'month').set('date', this.endDayOfMonth).startOf('day')
      }

      const date = firstDate.clone().subtract(1, 'day') // clone() preserva o UTC?
      const weeks = []

      const today = moment()
      const yesterday = moment().subtract(1, 'days')

      while (date.isBefore(lastDate, 'day')) {
        weeks.push({
          // shouldDuplicate: true,
          value: Array(7).fill(0).map(() => {
            const day = date.add(1, 'day').clone() // clone() preserva o UTC?
            const isExpired = day.isBefore(yesterday)
            const isToday = day.isSame(today, 'day')

            const dayTimestamp = day.unix() * 1000
            const dayOfWeek = day.weekday()
            const dayFmt = day.format('DD/MM/YYYY')
            const dayFmtWzero = day.format('YYYY-M-D')
            const dayLabel = day.format('DD/MM')
            const dayFmtYmd = day.format('YYYY-MM-DD')
            const dayTitle = day.format('ddd - DD/MM')

            return {
              floatCurrentTime: hhmmToFloat(moment().format('HH:mm')),
              day,
              dayTitle,
              dayTimestamp,
              dayOfWeek,
              dayFmt,
              dayFmtWzero,
              dayLabel,
              dayFmtYmd,
              isExpired,
              isToday,
              disabled: this.shouldHideOnScale(day),
            }
          }),
        })
      }

      weeks.forEach((week, index) => {
        week.firstDayOfWeek = week.value[0].day.format('DD-MM-YYYY')
        week.showWeek = !(this.shouldHideOnScale(week.value[6].day) && this.shouldHideOnScale(week.value[0].day))
      })

      // weeks (no componente local EditScale e ViewScale)

      if (output === 'prebuild') {
        // [24/01/25] console.log(`::: PRE CRREGAMENTO DE SEMANAS EM ${month}/${year}:`, weeks)
        this.preLoadedWeeks = weeks
      } else if (output === 'weeks') {
        // [24/01/25] console.log(`::: SEMANAS EM ${month}/${year}:`, weeks)
        this.weeks = weeks
      } else {
        // [24/01/25] console.log(`::: [BOTH] SEMANAS EM ${month}/${year}:`, weeks)
        this.preLoadedWeeks = weeks
        this.weeks = weeks
      }
    },

    shouldHideOnScale (day) {
      // console.log('Day: ' + moment(day).format('DD/MM/YYYY'))
      if (day) {
        const date = moment.isMoment(day) ? day : moment(day)
        const monthDifference = date.month() - this.actualMonth
        const dayOfMonth = date.date()
        if (day && this.startDayOfMonth > 0 && (monthDifference === 0 && dayOfMonth < this.startDayOfMonth || monthDifference < 0)) {
          return true
        }
        if (day && this.endDayOfMonth > 0 && (monthDifference > 0 && dayOfMonth > this.endDayOfMonth)) {
          return true
        }
      }
      return false
    }
  },
}
